
const defaultState = {
  cardnumber: null,
  program: null,
  errorMessage: null,
  dataStatus: 'none',
  clubs: [],
  selectedCardIndex: null
};

export default function (state = defaultState, action) {
  switch(action.type) {
    case 'USER_INFO_LOADED': 
      return {
        ...state,
        cardnumber: action.cardnumber,
        program: action.program        
      }
    case 'CLUBS_LOADED':
      return {
        ...state,
        clubs: action.clubs,
        selectedCardIndex: 0,
        errorMessage: null
      }
    case 'SELECTED_CARD_INDEX_UPDATED':
      return {
        ...state,
        selectedCardIndex: action.index
      }
    case 'THROW_ERROR':
      return {
        ...state,
        errorMessage: action.message
      }
    case 'DATA_STATUS':
      return {
        ...state,
        dataStatus: action.status,
        errorMessage: null
      }
    default:
      return state    
  }
}


// WEBPACK FOOTER //
// ./src/store/reducer.js